module.exports = __webpack_public_path__ + "static/img/close.d30f018.png";


//////////////////
// WEBPACK FOOTER
// ./src/imageViewer/icon/close.png
// module id = PC9L
// module chunks = 50